import PersonDetailTabs from './PersonDetailTabs.container';
export default PersonDetailTabs;
